import { render, staticRenderFns } from "./ChatterTimeline.vue?vue&type=template&id=53a35784&scoped=true"
import script from "./ChatterTimeline.vue?vue&type=script&lang=js"
export * from "./ChatterTimeline.vue?vue&type=script&lang=js"
import style0 from "./ChatterTimeline.vue?vue&type=style&index=0&id=53a35784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a35784",
  null
  
)

export default component.exports